<!-- <label class="badge p-2" [ngClass]="severity">{{ severity | uppercase }}</label> -->
<div
  *ngIf="isDataValid"
  [nbTooltip]="badgeTooltipText"
  [nbTooltipDisabled]="!badgeTooltipText?.length"
>
  <label
    class="badge {{ badgeClass }}"
    [ngClass]="severity"
    [style.background]="background ? background : ''"
    [style.color]="color ? color : ''"
    [style.height]="'fit-content'"
    [style.border]="border"
  >
    <ng-container *ngIf="customText">{{
      textCase === 'uppercase' ? (customText | uppercase) : customText
    }}</ng-container>
    <ng-container *ngIf="!customText">{{
      textCase === 'uppercase' ? (severity | uppercase) : severity
    }}</ng-container>
  </label>
  <img
    class="ml-2 cursor-pointer"
    style="height: 1rem"
    *ngIf="showImg"
    (click)="sendEvent()"
    [nbTooltip]="imgTooltip"
    [nbTooltipDisabled]="!imgTooltip"
    [src]="imgUrl"
  />
</div>
<div *ngIf="!isDataValid">
  <span>N/A</span>
</div>
